@if (entryData().isComplex === false) {
  <div>
    <div class="annotations-parent">
      <div class="annframe-container">
        <div class="main-annotaion">
          @if (isOldUniprotEntry) {
            <section class="notification">
              <notification-msg
                [type]="'warning'"
                [message]="'This AlphaFold model was generated using a prior version of the UniProt sequence.'">
              </notification-msg>
            </section>
          }

          <app-heatmap
            [accession]="accession"
            [amAnnotationsHg19Url]="entryData().amAnnotationsHg19Url"
            [amAnnotationsHg38Url]="entryData().amAnnotationsHg38Url"
            [csvAMFileUrl]="entryData().amAnnotationsUrl"
            [heatmapSequence]="entryData().sequence"
            [csvAmData]="csvAmData()"
            [plddtData]="plddtData"
            [plddtDocUrl]="entryData().plddtDocUrl"
            [isComplex]="entryData().isComplex"
            [assemblyType]="entryData().assemblyType"
            [colorScheme]="colorScheme"
            (onChangeColor)="updateColorScheme($event)"
            (onProtvistaMouseEvent)="triggerMolstarEvents($event)"
            (selectedCategory)="amSelectionCategory($event)"
            (selectedRegion)="amSelectionUpdate($event)"
            (clearRegion)="amSelectionClear()"
          ></app-heatmap>
        </div>
        <div class="main-structure">
          @if (colorScheme.includes('plddt')) {
            <div class="legends">
              <linear-legends type="plddt"></linear-legends>
            </div>
          }
          @if (colorScheme.includes('missense')) {
            <div class="legends">
              <linear-legends type="missense"></linear-legends>
            </div>
          }
          @if (colorScheme.includes('custom')) {
            <div class="legends">
              <div style="height: 43px;"></div>
            </div>
          }
          <!-- <div *ngIf="dropdownSelected.includes('Domain')">
          <div
            [ngClass]="{ 'scrollable-body': tedDomainData().length > 5, 'non-scrollable-body': tedDomainData().length <= 5 }">
            <div *ngIf="tedDomainData().length > 0" class="legend-title">TED</div>
            <div class="modelInfo">
              <div *ngIf="tedDomainData().length > 0" class="confidenceWrapper">
                <div
                  class="column legendRow"
                  *ngFor="let ted of slicedTedDomain(); index as i">
                  <span class="legendColor"
                  [style.background]="utilService.fetchColorByIndex(i)">&nbsp;</span>
                  <span class="legendlabel">Domain {{ ted.ted_domain_no }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>  -->
        <div class="annotations-molstar-container"></div>
        <div class="paecontainer">
          @if (entryData().paeDocUrl) {
            <app-pae-view
              [accession]="accession" [paeid]="'annotations-paeviewer'"
              [paeDocUrl]="entryData().paeDocUrl"
              [imageUrl]="entryData().paeImageUrl"
              [length]="entryData().sequenceEnd"
              (selectedRegion)="cmSelectionUpdate($event)">
            </app-pae-view>
          }
        </div>
      </div>
    </div>
  </div>
</div>
}
@if (entryData().isComplex === true) {
  <div>
    <div class="no-domain-parent" >
      <div class="no-domain-information">No annotations available</div>
      <div class="no-domain-notes">Annotations will appear here as new data is added in future updates.</div>
    </div>
  </div>
}